import moment from 'ct-moment';

// unix time is in seconds so it must be converted to milliseconds for moment
export const formatUnixTime = (timeProvider) => (unixTime) => timeProvider(unixTime * 1000).format('HH:mm');

export default formatUnixTime(moment);
